import React from "react";
import { Link } from 'react-router-dom';
import Header from '../common/header/Header';
import FooterOne from '../common/footer/FooterOne';
import SEO from '../common/SEO';

const AboutUs = () => {
    return (
        <>
            <SEO title="About Us - East Coast Coders LLC" />
            <main className="main-wrapper">
                <Header />

                {/* Centered Content */}
                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh', padding: '2rem', marginTop: '80px' }}>
                    <div className="text-center" style={{ maxWidth: '800px', width: '100%' }}>

                        {/* Header */}
                        <h1 className="mb-4 fw-bold" style={{ fontSize: '2.5rem', color: 'var(--color-heading)' }}>
                            About East Coast Coders LLC
                        </h1>

                        {/* Content */}
                        <div className="mb-5">
                            <div className="mb-3 p-3" style={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '12px',
                                border: '1px solid #e9ecef'
                            }}>
                                <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 'normal' }}>East Coast Coders LLC was founded by William Hunt with a singular vision—to spotlight the strength, ingenuity, and determination of the East Coast's vast technology talent. While the West Coast often dominates the tech narrative, the East has long been the birthplace of foundational innovation. The company stands as both a technology firm and a declaration that excellence thrives in the historic corridors of the East—where creativity meets grit, and where a strong work ethic drives measurable results. Today, that same drive fuels the company's push into artificial intelligence—building AI-enhanced tools and services that keep clients ahead of the curve.</p>
                            </div>
                            <div className="mb-3 p-3" style={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '12px',
                                border: '1px solid #e9ecef'
                            }}>
                                <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 'normal' }}>The spirit of Benjamin Franklin, Thomas Edison, and the brilliant minds of Bell Labs runs through the DNA of East Coast Coders. These pioneers didn't just invent—they reshaped the world through experimentation, precision, and relentless curiosity. The company draws inspiration from that lineage, combining classical engineering rigor with modern software innovation. It's a nod to a region that built America's technological backbone and continues to define what progress looks like.</p>
                            </div>
                            <div className="mb-5 p-3" style={{
                                backgroundColor: '#f8f9fa',
                                borderRadius: '12px',
                                border: '1px solid #e9ecef'
                            }}>
                                <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 'normal' }}>With world-class universities in Boston, New York, and Philadelphia, the East Coast remains a fertile ground for thinkers, builders, and creators. East Coast Coders is on a mission to unite this community—to attract engineers, designers, AI specialists, and innovators who share a belief that purpose and precision can coexist. This is more than a company—it's a movement to remind the industry that the brightest ideas don't just come from one coast, but from a legacy of brilliance that has always called the East home.</p>
                            </div>
                        </div>

                        {/* Contact Button */}
                        <div>
                            <Link
                                to="/"
                                className="axil-btn btn-fill-primary"
                                style={{
                                    padding: '15px 30px',
                                    fontSize: '1.1rem',
                                    textDecoration: 'none',
                                    display: 'inline-block'
                                }}
                                onClick={() => {
                                    // Small delay to allow navigation to complete, then scroll to about section
                                    setTimeout(() => {
                                        const aboutSection = document.querySelector('.section.section-padding-equal.bg-color-light');
                                        if (aboutSection) {
                                            aboutSection.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }, 200);
                                }}
                            >
                                Contact Us
                            </Link>
                        </div>

                    </div>
                </div>

            </main>
        </>
    );
};

export default AboutUs;
